import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@evaneos/b2b-ui';
import CloseOutlinedIcon from '@evaneos/b2b-ui/icons/CloseOutlined';
import { useIntl } from 'react-intl';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const AppointmentDisconnectConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
}: Props): JSX.Element => {
    const { formatMessage } = useIntl();

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="disconnect-dialog-title"
            slotProps={{ paper: { sx: { padding: 3, maxWidth: 560, borderRadius: 2 } } }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <DialogTitle
                    id="disconnect-dialog-title"
                    variant="h2"
                    sx={{ p: 0, fontWeight: 700 }}
                >
                    {formatMessage({ id: 'appointment.disconnect_dialog.title' })}
                </DialogTitle>
                <IconButton onClick={onClose} aria-label={formatMessage({ id: 'global.close' })}>
                    <CloseOutlinedIcon />
                </IconButton>
            </Box>
            <DialogContent sx={{ px: 0 }}>
                <Alert severity="error">
                    {formatMessage({ id: 'appointment.disconnect_dialog.warning' })}
                </Alert>
            </DialogContent>
            <DialogActions sx={{ px: 0, justifyContent: 'flex-start' }}>
                <Button
                    data-spec-id="agenda-disconnect-confirm-button"
                    variant="contained"
                    color="error"
                    onClick={onConfirm}
                >
                    {formatMessage({ id: 'appointment.disconnect_dialog.confirm_button' })}
                </Button>
                <Button variant="outlined" onClick={onClose}>
                    {formatMessage({ id: 'form.cancel' })}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
